import React, { Component } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";
import logo from "../../assets/images/logo3.png";
import { withRouter2 } from "../withRouter2";
import { UserContext } from "../../UserContext";

class Navbar extends Component {
  static contextType = UserContext;

  componentDidMount() {
    const { user } = this.context;
    // console.log("User dans Navbar:", user);
  }

  toggleOffcanvas = () => {
    document.querySelector(".sidebar-offcanvas")?.classList.toggle("active");
  };

  toggleRightSidebar = () => {
    document.querySelector(".right-sidebar")?.classList.toggle("open");
  };

  handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_info");

    this.context.setUser(null);

    this.props.router.navigate("/login");
  };

  handleBack = () => {
    // this.props.router.navigate(-1);
    this.props.router.navigate("/menp");
  };

  render() {
    const { user } = this.context;

    return (
      <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
          <Link className="navbar-brand brand-logo" to="/">
            <img src={logo} alt="logo" />
          </Link>

          <Link className="navbar-brand brand-logo-mini" to="/">
            <img
              src={require("../../assets/images/logo_fenasu.png")}
              alt="logo"
            />
          </Link>
        </div>

        <div className="navbar-menu-wrapper d-flex align-items-stretch">
          <button
            className="navbar-toggler align-self-center"
            type="button"
            onClick={() => document.body.classList.toggle("sidebar-icon-only")}
          >
            <span className="mdi mdi-menu"></span>
          </button>

          <ul className="navbar-nav navbar-nav-right">
            <li className="nav-item nav-profile">
              <Dropdown align="end">
                <Dropdown.Toggle className="nav-link">
                  <div className="nav-profile-text">
                    <p className="mb-1 text-black">
                      {user && user.email ? user.email : "Invité"}
                    </p>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className="navbar-dropdown">
                  <Dropdown.Item onClick={this.handleBack}>
                    <i className="mdi mdi-arrow-left mr-2 text-primary"></i>
                    <Trans>Back</Trans>
                  </Dropdown.Item>

                  <Dropdown.Item onClick={this.handleLogout}>
                    <i className="mdi mdi-logout mr-2 text-primary"></i>
                    <Trans>Signout</Trans>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </ul>

          <button
            className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            onClick={this.toggleOffcanvas}
          >
            <span className="mdi mdi-menu"></span>
          </button>
        </div>
      </nav>
    );
  }
}

export default withRouter2(Navbar);
